<template>
	<div class="innerBox">
		<h2 class="mb-4">Payments</h2>

		<div class="row ml-3 mr-3">
			<div class="col-12 text-center"><h5>Payment Type</h5></div>
			<div class="col-12 col-md-4 pr-3 pl-3">
				<div v-if="incomingList.length > 0" class="mt-2 pr-3 pl-3  pt-4 pb-4 shadow rounded hoverable" @click="paymentInput.value = 'Incoming'" :class="{'selected' : paymentInput.value == 'Incoming'}">
					<div class="row">
						<div class="col-3 text-center">
							<i class="fas fa-sign-in-alt fa-4x"></i>
						</div>
						<div class="col-9">
							<h6>Incoming Payment</h6>
							<!-- <br> -->
							Kas Masuk Dari Sumber Eksternal
						</div>
					</div>
				</div>
				<div v-else class="mt-2 pr-3 pl-3  pt-4 pb-4 shadow rounded bg-grey" >
					<div class="row">
						<div class="col-3 text-center">
							<i class="fas fa-sign-in-alt fa-4x"></i>
						</div>
						<div class="col-9">
							<h6>Incoming Payment</h6>
							<!-- <br> -->
							Kas Masuk Dari Sumber Eksternal
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-4 pr-3 pl-3">
				<div v-if="transferList.length > 0" class="mt-2 pr-3 pl-3  pt-4 pb-4 shadow rounded hoverable" @click="paymentInput.value = 'Transfer'" :class="{'selected' : paymentInput.value == 'Transfer'}">
					<div class="row">
						<div class="col-3 text-center">
							<i class="fas fa-random fa-4x"></i>
						</div>
						<div class="col-9">
							<h6>Transfer Asset</h6>
							<!-- <br> -->
							Transfer Kas ke Kas Lain
						</div>
					</div>
				</div>
				<div v-else class="mt-2 pr-3 pl-3  pt-4 pb-4 shadow rounded bg-grey">
					<div class="row">
						<div class="col-3 text-center">
							<i class="fas fa-random fa-4x"></i>
						</div>
						<div class="col-9">
							<h6>Transfer Asset</h6>
							<!-- <br> -->
							Transfer Kas ke Kas Lain
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-4 pr-3 pl-3">
				<div v-if="outgoingList.length > 0" class="mt-2 pr-3 pl-3  pt-4 pb-4 shadow rounded hoverable" @click="paymentInput.value = 'Outgoing'" :class="{'selected' : paymentInput.value == 'Outgoing'}">
					<div class="row">
						<div class="col-3 text-center">
							<i class="fas fa-sign-out-alt fa-4x"></i>
						</div>
						<div class="col-9">
							<h6>Outgoing Payment</h6>
							<!-- <br> -->
							Pembayaran Dari Bengkel ke Sumber Lain
						</div>
					</div>
				</div>
				<div v-else class="mt-2 pr-3 pl-3  pt-4 pb-4 shadow rounded bg-grey">
					<div class="row">
						<div class="col-3 text-center">
							<i class="fas fa-sign-out-alt fa-4x"></i>
						</div>
						<div class="col-9">
							<h6>Outgoing Payment</h6>
							<!-- <br> -->
							Pembayaran Dari Bengkel ke Sumber Lain
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="mt-4" v-if="accountTransactionList">
			<incoming-payment 
				:accountTransaction="incomingList"
				v-if="paymentInput.value == 'Incoming'" 
				@recheckBalance="getAccountList"
			/>
			<outgoing-payment 
				v-else-if="paymentInput.value == 'Outgoing'"
				:accountTransaction="outgoingList"
				@recheckBalance="getAccountList"
			/>
			<transfer 
				:accountTransaction="transferList"
				v-else
				@recheckBalance="getAccountList"
			/>
		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'

import IncomingPayment from './children/IncomingPayements.vue'
import Transfer from './children/Transfer.vue'
import OutgoingPayment from './children/OutgoingPayments.vue'


export default {
	components : {
		Multiselect,
		OutgoingPayment,
		Transfer,
		IncomingPayment
	},
	data () {
		return {
			paymentInput : {
				value : 'Incoming',
			},
			accountTransactionList : null,
			incomingList : [],
			outgoingList : [],
			transferList : []

		}
	},
	mounted () {
		this.getAccountList()
	},
	methods : {
		getAccountList() {
			this.$http.get('/api/v1/transactions/account-list')
			.then((resp) => {
				this.accountTransactionList = resp.data.data

				for(var i = 0 ; i < this.accountTransactionList.length ; i++) {
					let curAccount = this.accountTransactionList[i]
					this.$http.get('/api/v1/transactions/account-balance?account_transaction_id=' + curAccount.id)
					.then((resp) => {
						curAccount.balance = resp.data.data
					}).catch((err) => {
						console.log(err)
					})
				}

				this.incomingList = this.accountTransactionList.filter(x => x.allow_incoming)
				this.transferList = this.accountTransactionList.filter(x => x.allow_transfer)
				this.outgoingList = this.accountTransactionList.filter(x => x.allow_outgoing)

				if(this.incomingList.length > 0) {
					this.paymentInput.value = 'Incoming'
				}
				else if(this.transferList.length > 0 ) {
					this.paymentInput.value = 'Transfer'
				}
				else {
					this.paymentInput.value = 'Outgoing'
				}

			})
			.catch((err) => {
				console.log(err)
			})
		}
	}
}
</script>

<style scoped>
	.selected {
		border : 1px solid rgba(0,88,168,1);
	}

	.hoverable:hover {
		color : white;
		background-color : #448;
	}
</style>